import { Avatar } from "@mantine/core";

const MantineAvathar = (props: any) => {
    const {
        src,
        children,
        color,
        size,
        radius,
        alt,
        variant,
        className
    } = props;
    return (
        <Avatar
            src={src}
            alt={alt}
            color={color}
            size={size}
            radius={radius}
            variant={variant}
            className={className}
        >
            {children}
        </Avatar>
    );
};

export default MantineAvathar;